export const getSectorLogo = (sectorName) => {
    if (!sectorName) return null;
    const normalizedName = sectorName.toLowerCase().trim();

    const logoMap = {
        'btp': 'NF_logo_btp.png',
        'transport': 'NF_logo_transport.png',
        'immobilier': 'NF_logo_immo.png',
        'communication': 'NF_logo_com.png',
        'services': 'NF_logo_service.png',
        'sécurité': 'NF_logo_security.png',
        'securite': 'NF_logo_security.png',
        'security': 'NF_logo_security.png',
        'import/export': 'NF_logo_import-export.png',
        'import-export': 'NF_logo_import-export.png',
        'import_export': 'NF_logo_import-export.png',
        'importexport': 'NF_logo_import-export.png'
    };

    // Try exact match first
    if (logoMap[normalizedName]) {
        return `/images/logo/${logoMap[normalizedName]}`;
    }

    // Try keyword match
    for (const [key, filename] of Object.entries(logoMap)) {
        if (normalizedName.includes(key)) {
            return `/images/logo/${filename}`;
        }
    }

    return null;
};
